
const analyzeNumber = Symbol.for('analyze-number');

String.prototype[analyzeNumber] = function() {

    // Restricts max value up to 1 billion with decimals or up to 100 billions if integer

    if(this.replace(/[.-]/gi, '').length > 11) {
        return false;
    }

    // Calculating qty of '.' and '-'

    let counter1 = 0;
    let counter2 = 0;

    Array.from(this).forEach(function(char){
        char === '.' && counter1++;
        char === '-' && counter2++;
    });

    // If there is a float part except providing more than 2 decimals

    if(counter1 === 1) {
        if (this.split('.')[1].length > 2) {
            return false;
        }
    }

    // Preventing providing minus sign on positions except the first one

    if(counter2 === 1) {
        if(this.indexOf('-') !== 0) {
            return false;
        }
    }

    return counter1 < 2 && counter2 <= 1;
};

export const processReplacements = function(args) {
    const regexpQuoteHelper = function(str) {
        return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    };

    const replacement = typeof(args) === 'string' ? JSON.parse(args) : args;
    let myself = this;
    Object.keys(replacement)
        .filter(function(key) { return key in replacement; })
        .forEach(function(key)
        {
            const regex = new RegExp(regexpQuoteHelper('${' + key + '}'), 'g');
            myself = myself.replace(regex, replacement[key]);
        });

    return myself;
};

String.prototype.processReplacements = processReplacements;

String.prototype.toCamelCase = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

const cloneFunction = Symbol.for('clone-function');

Function.prototype[cloneFunction] = function() {
    const func = this;
    const clone = function() {
        return func.apply(this, arguments);
    };
    clone.prototype = func.prototype;
    for (let prop in func) {
        /*eslint-disable */
        if (func.hasOwnProperty(prop) && prop !== 'prototype') {
        /*eslint-enable */
            clone[prop] = func[prop];
        }
    }
    return clone;
};
